import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Tabs from './tabs/index.md';
import InitializeSDK from '/src/pages/resources/initialize.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const TabsBlock = makeShortcode("TabsBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "identity"
    }}>{`Identity`}</h1>
    <p>{`The Identity for Experience Cloud ID Service extension enables your app with the Experience Cloud ID (ECID). This service helps with the synchronization of Adobe and other customer identifiers.`}</p>
    <p>{`Include the Identity extension in your application when using any of the following Adobe Solution extensions:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../../../solution/adobe-analytics/index.md"
        }}>{`Adobe Analytics`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../../../solution/adobe-audience-manager/index.md"
        }}>{`Adobe Audience Manager`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../../../solution/adobe-campaign-standard/index.md"
        }}>{`Adobe Campaign Standard`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../../../solution/adobe-media-analytics/index.md"
        }}>{`Adobe Media Analytics`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../../../solution/adobe-target/index.md"
        }}>{`Adobe Target`}</a></li>
    </ul>
    <p>{`If your application uses the `}<a parentName="p" {...{
        "href": "../../../../edge/edge-network/index.md"
      }}>{`Edge Network extension`}</a>{`, then it must include the `}<a parentName="p" {...{
        "href": "../../../../edge/identity-for-edge-network/index.md"
      }}>{`Identity for Edge Network extension`}</a>{`. The Identity for Edge Network extension does not replace the Identity for Experience Cloud ID Service extension and both may be required in an application. See the `}<a parentName="p" {...{
        "href": "../../../../edge/identity-for-edge-network/faq.md"
      }}>{`FAQ`}</a>{` for more information.`}</p>
    <p>{`When using third party extensions, check with the extension developer to understand if the Identity extension is a required dependency.`}</p>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`On web or other platforms, there might situations where this extension might not be required, and the implementation of this SDK extension on mobile apps is required.`}</p>
    <p>{`To get started with Identity, complete the following steps:`}</p>
    <ol>
      <li parentName="ol">{`Add the `}<strong parentName="li">{`Identity`}</strong>{` extension to your app.`}</li>
      <li parentName="ol">{`Implement the SDK APIs to complete the following tasks:`}
        <ul parentName="li">
          <li parentName="ul">{`Update customer IDs.`}</li>
          <li parentName="ul">{`Append Adobe visitor data to a URL string.`}</li>
          <li parentName="ul">{`Return customer IDs.`}</li>
          <li parentName="ul">{`Retrieve Experience Cloud IDs.`}</li>
          <li parentName="ul">{`Set advertising IDs.`}</li>
          <li parentName="ul">{`Set the device notification for push notifications.`}</li>
        </ul>
      </li>
    </ol>
    <h2 {...{
      "id": "add-the-identity-extension-to-your-app"
    }}>{`Add the Identity extension to your app`}</h2>
    <h3 {...{
      "id": "include-identity-extension-as-an-app-dependency"
    }}>{`Include Identity extension as an app dependency`}</h3>
    <p>{`Add Identity extensions as dependencies to your project.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`Kotlin`}<br />{`(Android)`}</p>
    <Tabs query="platform=android-kotlin&task=add" mdxType="Tabs" />
    <p>{`Groovy`}<br />{`(Android)`}</p>
    <Tabs query="platform=android-groovy&task=add" mdxType="Tabs" />
    <p>{`CocoaPods`}<br />{`(iOS)`}</p>
    <Tabs query="platform=ios-pods&task=add" mdxType="Tabs" />
    <h3 {...{
      "id": "initialize-adobe-experience-platform-sdk-with-identity-extension"
    }}>{`Initialize Adobe Experience Platform SDK with Identity Extension`}</h3>
    <p>{`Next, initialize the SDK by registering all the solution extensions that have been added as dependencies to your project with Mobile Core. For detailed instructions, refer to the `}<a parentName="p" {...{
        "href": "/client-sdks/src/pages/home/getting-started/get-the-sdk/#2-add-initialization-code"
      }}>{`initialization`}</a>{` section of the getting started page.`}</p>
    <p>{`Using the `}<inlineCode parentName="p">{`MobileCore.initialize`}</inlineCode>{` API to initialize the Adobe Experience Platform Mobile SDK simplifies the process by automatically registering solution extensions and enabling lifecycle tracking.`}</p>
    <InitializeSDK query="componentClass=TabsBlock" mdxType="InitializeSDK" />
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`Previously known as MCID/MID/MCMID, the Experience Cloud ID (ECID) is a 38 character ID that uniquely identifies each visitor in the Adobe Experience Platform.`}</p>
    <p>{`After the configuration is complete, an ECID is generated and, where applicable, is included on all Analytics and Audience Manager hits. Other IDs, such as custom and automatically-generated IDs, continue to be sent with each hit.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      